var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',_vm._g({attrs:{"type":"hidden","id":_vm.id,"name":_vm.name,"value":_vm.value,"disabled":_vm.disabled,"readonly":_vm.readonly,"required":_vm.required}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }